export default "__VITE_ASSET__CDLLaO3k__"